'use client';

import React, { createContext, ReactNode, useContext } from 'react';
import type { CurrentUserState } from '@/utils/user-helper';

const ServerUserStateContext = createContext<CurrentUserState | undefined>(undefined);

export interface ServerUserStateProviderProps {
  /** What the server already knows about the current user, on pages that need it. */
  userState?: CurrentUserState;
  children: ReactNode;
}

/** Lets the first render use the server's answer before the client has checked the session. */
export function ServerUserStateProvider({
  userState,
  children,
}: Readonly<ServerUserStateProviderProps>) {
  return (
    <ServerUserStateContext.Provider value={userState}>{children}</ServerUserStateContext.Provider>
  );
}

export function useServerUserState(): CurrentUserState | undefined {
  return useContext(ServerUserStateContext);
}
